import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import { catalogoList } from "../../services/CatalogoServices";
import { useNavigate } from "react-router-dom";
import SliderProgress from "../../layout/SliderProgress";
import BreadcrumbBar from "../../layout/BreadcrumbBar";
import TablaAyuda from "./Tabla";
import MUIXDataGrid from './MUIXDataGrid';
import AyudasModal from "./AyudaModal";
import { deleteFile, getAyuda } from "./ServicesAyuda";
import Swal from 'sweetalert2';
import { alertaError, alertaExito } from './toast';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { GridColDef } from "@mui/x-data-grid";


export interface IAyudaVideo {
  Id: string,
  IdMenu: string,
  Menu: string,
  NombreArchivo: string,
  RutaVideo: string,
  UltimaActualizacion: string
}

export interface IAyudaGuia {
  Id: string,
  IdMenu: string,
  Menu: string,
  NombreArchivo: string,
  RutaGuia: string,
  Pregunta: string,
  UltimaActualizacion: string
}

export interface IAyudaPregunta {
  Id: string,
  IdMenu: string,
  Menu: string,
  Respuesta: string,
  Pregunta: string,
  UltimaActualizacion: string
}


const AdministracionAyuda = () => {
  
  const [dataLoading, setDataLoading] = useState(false);
  const [valueTab, setvalueTab]       = useState<string>("Guías");
  const [Preguntas, setPreguntas]     = useState<IAyudaPregunta[]>([]);
  const [Guías, setGuias]             = useState<IAyudaGuia[]>([]);
  const [Videos, setVideos]           = useState<IAyudaVideo[]>([]);
  const [open, setOpen]               = useState(false);

  function eliminar(v: any) {
    Swal.fire({
          title: "¿Estás seguro de eliminar este registro?",
          icon: "question",
          showCancelButton: true,

          cancelButtonColor: "#af8c55",
          cancelButtonText: "CANCELAR",
          confirmButtonText: "ELIMINAR",
          confirmButtonColor: "#15212f",
        }).then((result) => {
          if (result.isConfirmed) {

            deleteFile(v?.row?.RutaGuia, v?.row?.NombreArchivoServidor, v?.row?.Id,obtenerDatos)
              .then((response) => {obtenerDatos();
                return true
                // alertaExito(, "¡REGISTRO ELIMINADO!");
                // 
              })
              .catch((error) => {
                return false
                //alertaError();
              });
          }
        });
    }

    const columnsGuia: GridColDef[] = [

      {
          field: "Acciones",
          disableExport: true,
          headerName: "ACCIONES",
          //description: "Acciones",
          sortable: false,
          width: 100,
          renderCell: (v: any) => {

              return (
                  <Box>
                      <Tooltip title="ELIMINAR GUÍA">
                          <IconButton onClick={() => {
                              eliminar(v)
                          }
                          }>
                              <DeleteForeverIcon />
                          </IconButton>
                      </Tooltip>
                  </Box>
              );
          },
      },
      {
          field: "Menu", headerName: "MENÚ",
          //description: "Menú", 
          width: 250
      },
      {
          field: "Pregunta",
          headerName: "PREGUNTA",
          //description: "Pregunta",
          width: 600,
      },
      {
          field: "NombreArchivo",
          headerName: "NOMBRE GUÍA",
          //description: "Nombre Guía",
          width: 550,
      },
  ];


  const columnsVideo: GridColDef[] = [
    {
        field: "Acciones",
        disableExport: true,
        headerName: "ACCIONES",
        //description: "Acciones",
        sortable: false,
        width: 100,
        renderCell: (v: any) => {
            return (
                <Box>
                    <Tooltip title="ELIMINAR VIDEO">
                        <IconButton onClick={() => { eliminar(v) }}>
                            <DeleteForeverIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            );
        },
    },
    {
        field: "Menu", headerName: "MENÚ",
        //description: "Menú", 
        width: 250
    },
    {
        field: "NombreArchivo",
        headerName: "NOMBRE VIDEO",
        //description: "Nombre Video",
        width: 550,
    },
    
];

const columnsPreguntas: GridColDef[] = [
  {
      field: "Acciones",
      disableExport: true,
      headerName: "ACCIONES",
      //description: "Acciones",
      sortable: false,
      width: 100,
      renderCell: (v: any) => {
          return (
              <Box>
                  <Tooltip title="ELIMINAR PREGUNTA">
                      <IconButton onClick={() => { eliminar(v) }
                      }>
                          <DeleteForeverIcon />
                      </IconButton>
                  </Tooltip>
              </Box>
          );
      },
  },
  // {
  //     field: "id",
  //     headerName: "Id",
  //     //description: "Menú", 
  //     width: 250
  // },
  {
      field: "Menu",
      headerName: "MENÚ",
      //description: "Menú", 
      width: 250
  },
  {
      field: "Pregunta",
      headerName: "PREGUNTA",
      //description: "Pregunta",
      width: 600,
  },
  {
      field: "Texto",
      headerName: "RESPUESTA",
      //description: "Respuesta",
      width: 800,
  },
  
];

const handleOpen = (v: any) => {

  setOpen(true);

};

const handleClose = () => {
  setOpen(false);
  obtenerDatos();
};


const obtenerDatos = () => {
  if (valueTab === "Guías") {
      getAyuda(setGuias, "0", "Guías")
  }
  if (valueTab === "Videos") {
      getAyuda(setVideos, "0", "Videos")
  }
  if (valueTab === "Preguntas") {
      getAyuda(setPreguntas, "0", "Preguntas")            
  }
}

useEffect(() => {
  obtenerDatos();
}, [valueTab])

  return (
    <>
      <Grid container spacing={1} sx={{ mt: 3 }}>
        <BreadcrumbBar
          links={[
            { texto: "Inicio", link: "/admin" },
          
          ]}
          Titulo={"Administracion de la Ayuda"}
        />
      </Grid>
      <Grid container spacing={1} sx={{ mt: 2 }}>
        <SliderProgress open={dataLoading}></SliderProgress>

        <Grid container xs={12} justifyContent={"center"}>
                <Grid item xs={12} md={12} mt={2}>
                    <Card sx={{ p: 1, boxShadow: 6 }}>
                        <CardHeader
                        />
                        <Grid
                            sx={{
                                display: "flex",
                                alignItems: "right",
                                justifyContent: "right",
                                paddingBottom: "1%",
                                paddingRight: "1%",
                            }}
                        >
                            <Button
                                onClick={handleOpen}
                                variant="contained"
                                sx={{ margin: "1%", color: "#FFFFFF" }}
                            >
                                <Typography
                                    sx={{
                                        color: "#FFFFFF", "&:hover": { color: "#15212f" },
                                        fontFamily: "MontserratRegular, sans-serif",
                                        fontSize: "100%",
                                    }}
                                >
                                    Agregar
                                </Typography>
                            </Button>
                        </Grid>
                        <CardContent >
                            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                    <Tabs
                                        value={valueTab}
                                        //onChange={handleChange}
                                        textColor="inherit"
                                        variant="fullWidth"
                                        // este SX es de la barra donde se muestran los tabs
                                        sx={{
                                            "& .MuiTabs-indicator": {
                                                backgroundColor: "#bda889",
                                                heigth: 4,
                                            },
                                            "& .Mui-selected": { color: "#bda889" },
                                            "& button": { borderRadius: 5 },
                                            // pasa el mouse
                                            "& button:hover": {
                                                backgroundColor: "#bda889",
                                                color: "#ffffff",
                                            },
                                        }}
                                    >
                                        <Tab label="Guías" value="Guías"
                                            onClick={() => setvalueTab("Guías")}
                                        />
                                        <Tab label="Videos" value="Videos"
                                            onClick={() => setvalueTab("Videos")}
                                        />
                                        <Tab label="Preguntas" value="Preguntas"
                                            onClick={() => setvalueTab("Preguntas")}
                                        />
                                        {/* <Tab label="Bienes Inmuebles" {...a11yProps(2)} /> */}
                                    </Tabs>

                                    <Grid item sx={{ width: "100vw", height: "77vh" }}>
                                        {valueTab === "Preguntas" ? (
                                            <MUIXDataGrid id={(row: any) => row.Id} columns={columnsPreguntas} rows={Preguntas} />
                                        ) : null}

                                        {valueTab === "Videos" ? (
                                            <MUIXDataGrid id={(row: any) => row.Id} columns={columnsVideo} rows={Videos} />
                                        ) : null}

                                        {valueTab === "Guías" ? (
                                            <MUIXDataGrid id={(row: any) => row.Id} columns={columnsGuia} rows={Guías} />
                                        ) : null}
                                    </Grid>
                                    {open ? (
                                        <AyudasModal
                                            valueTab={valueTab}
                                            handleClose={handleClose}
                                        />
                                    ) : null}
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>


      </Grid>
    </>
  );
};
export default AdministracionAyuda;